import { useStore }  from '@/store/StoreContext'
import { useT, useLang } from '@/i18n/I18nContext'
import { LANG_META } from '../i18n/translations'

function Spinner({ size=18, color="var(--sky)" }) {
  return (
    <div style={{ width:size, height:size, border:`2.5px solid ${color}30`,
      borderTop:`2.5px solid ${color}`, borderRadius:"50%",
      animation:"spin .7s linear infinite", flexShrink:0 }}/>
  );
}


export default function SaveToast({status}){
  const t=useT();
  if(status==="idle") return null;
  const map={saving:{bg:"var(--navy)",txt:t("st.saving"),icon:<Spinner size={13} color="white"/>},saved:{bg:"var(--green)",txt:t("st.saved"),icon:"✓"},error:{bg:"var(--red)",txt:t("st.error"),icon:"✗"}};
  const m=map[status]||map.saving;
  return<div className="toast" style={{background:m.bg,color:"white",fontFamily:LANG_META["en"].family}}>{m.icon} {m.txt}</div>;
}